<template>
    <div class="modal fade in" id="enquiryForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="false" style="display: block; padding-right: 17px;">
        <div class="modal-backdrop fade in" style="height: 100%"></div>
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button @click.prevent="$emit('close')" type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h2 class="modal-title" id="enquiryFormLabel">QUICK ENQUIRY</h2>
                    <div class="divider">
                        <hr>
                    </div>
                    <h4>TELL US WHAT YOU WANT - WE'LL DO THE REST</h4>
                </div>
                <div class="modal-body">
                    <form data-parsley-validate="" action="?tx_sbchalets_pi1%5Bcontroller%5D=Booking" method="post" @submit.prevent="submit">
                        <div> <input type="hidden" name="tx_sbchalets_pi1[__referrer][@extension]" value="SbChalets" /> <input type="hidden" name="tx_sbchalets_pi1[__referrer][@vendor]" value="SkiBoutique" /> <input type="hidden" name="tx_sbchalets_pi1[__referrer][@controller]" value="Booking" /> <input type="hidden" name="tx_sbchalets_pi1[__referrer][@action]" value="enquiryPartial" /> <input type="hidden" name="tx_sbchalets_pi1[__referrer][arguments]" value="YTowOnt98f9b108764c374708c2d4451230d654eaa11b20e" /> <input type="hidden" name="tx_sbchalets_pi1[__referrer][@request]" value="a:4:{s:10:&quot;@extension&quot;;s:9:&quot;SbChalets&quot;;s:11:&quot;@controller&quot;;s:7:&quot;Booking&quot;;s:7:&quot;@action&quot;;s:14:&quot;enquiryPartial&quot;;s:7:&quot;@vendor&quot;;s:11:&quot;SkiBoutique&quot;;}81df9b2de54bd60dcc1a9da6aabf81c2e98f3fe6" /> <input type="hidden" name="tx_sbchalets_pi1[__trustedProperties]" value="a:14:{s:4:&quot;name&quot;;i:1;s:9:&quot;last_name&quot;;i:1;s:5:&quot;email&quot;;i:1;s:9:&quot;telephone&quot;;i:1;s:12:&quot;arrival_date&quot;;i:1;s:6:&quot;adults&quot;;i:1;s:8:&quot;children&quot;;i:1;s:14:&quot;enquiry_source&quot;;i:1;s:10:&quot;preference&quot;;i:1;s:4:&quot;text&quot;;i:1;s:7:&quot;keyword&quot;;i:1;s:8:&quot;campaign&quot;;i:1;s:2:&quot;ad&quot;;i:1;s:18:&quot;sendenquiryPartial&quot;;i:1;}961c6d424770ebc186d8ed3b45219f012cfd8c65" /> </div>

                        <div class="row">
                        <div class="form-group col-xs-6"> <input v-model="first_name" :class="{'form-control': true, 'parsley-error': errors.indexOf('first_name') !== -1}" placeholder="Name" type="text" name="tx_sbchalets_pi1[name]" required="required" aria-label="First Name" /> </div>
                        <div class="form-group col-xs-6"> <input v-model="last_name" :class="{'form-control': true, 'parsley-error': errors.indexOf('last_name') !== -1}" placeholder="Surname" type="text" name="tx_sbchalets_pi1[last_name]" required="required" aria-label="Last Name" /> </div>
                        <div class="form-group col-xs-12"> <input v-model="email" :class="{'form-control': true, 'parsley-error': errors.indexOf('email') !== -1}" placeholder="Email" type="text" name="tx_sbchalets_pi1[email]" required="required" aria-label="Email address" /> </div>
                        <div class="form-group col-xs-12"> <input v-model="phone" :class="{'form-control': true, 'parsley-error': errors.indexOf('phone') !== -1}" placeholder="Telephone" type="text" name="tx_sbchalets_pi1[telephone]" aria-label="Phone number" /> </div>
                        <div class="form-group col-xs-12">
                             <input v-model="arrival_date" placeholder="Arrival Date"  :class="{'form-control': true, 'arrival_date': true, 'parsley-error': errors.indexOf('arrival_date') !== -1}" type="text" required="required" name="tx_sbchalets_pi1[arrival_date]" aria-label="Arrival date">
                        </div>



                        <div class="form-group col-xs-6">
                            <select required="" v-model="adults" :class="{'form-control': true, 'parsley-error': errors.indexOf('adults') !== -1}" name="tx_sbchalets_pi1[adults]" aria-label="Number of adults">
                                <option value="">Adults</option>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                            </select>
                        </div>
                        <div class="form-group col-xs-6">
                            <select required="" :class="{'form-control': true, 'parsley-error': errors.indexOf('children') !== -1}" name="tx_sbchalets_pi1[children]" v-model="children" aria-label="Number of children">
                                <option value="0">Children</option>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                            </select>
                        </div>
                        <div class="form-group hidden">
                            <select class="form-control" name="tx_sbchalets_pi1[enquiry_source]" aria-label="How did you hear about us">
                                <option value="-1">Enquiry source</option>
                                <option value="0" selected="selected">Website - Perfect Chalet</option>
                                <option value="1">Website - Chalet Enquire Now</option>
                                <option value="2">Website - Chalet Price List</option>
                                <option value="3">Telephone</option>
                                <option value="4">Direct email</option>
                                <option value="5">Repeat guest</option>
                                <option value="6">Referral</option>
                                <option value="7">LinkedIn</option>
                                <option value="8">Facebook</option>
                                <option value="9">Website - Next Season</option>
                            </select>
                        </div>
                        <div class="form-group col-xs-12" v-if="resort_id">
                            <select required="" :class="{'form-control': true, 'parsley-error': errors.indexOf('flexible') !== -1}" name="tx_sbchalets_pi1[preference]" v-model="flexible" aria-label="Contact preference">
                                <option value="">{{ Number(site) === 2 ? 'VILLA PREFERENCE' : 'Resort Preference' }}</option>
                                <option value="0">{{ Number(site) === 2 ? 'IM ONLY INTERESTED IN THIS VILLA' : "I'm only interested in this resort" }}</option>
                                <option value="1" selected="selected">{{ Number(site) === 2 ? 'INSPIRE ME ON A VILLA' : "I'm flexible on resort" }}</option>
                            </select>
                        </div>
                        <div class="form-group col-xs-12">
                            <textarea rows="5" cols="20" v-model="message" placeholder="TELL US WHAT YOU'RE LOOKING FOR IN ONE SHORT PARAGRAPH (A ROUGH BUDGET INDICATION  IS VERY HELPFUL)" class="form-control" name="tx_sbchalets_pi1[text]" aria-label="Message or enquiry details"></textarea> </div>
                        <div class="form-group col-xs-12"> </div>
                        <input type="hidden" name="tx_sbchalets_pi1[keyword]" value="" /> <input type="hidden" name="tx_sbchalets_pi1[campaign]" value="" /> <input type="hidden" name="tx_sbchalets_pi1[ad]" value="" />
                        <input type="hidden" name="gclid" value="" />
                        <div class="col-xs-12">
                            <input class="btn btn-default" type="submit" value="Send" aria-label="Submit enquiry" />
                            <div v-if="server_errors.length" class="alert alert-danger enquiry-form-alert-modal" role="alert">
                                <div v-for="(error, index) in server_errors" :key="index">{{ error }}</div>
                            </div>
                        </div>
                    </div>
                    </form>
                </div>
                <div class="modal-footer"> </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Enquiry from "../../src/Enquiry";
    import EnquiryMessage from "../../src/EnquiryMessage";

    import DatePick from 'vue-date-pick';
    import 'vue-date-pick/dist/vueDatePick.css';
    import {initArrivalDatepickers} from './shared/datepickers';

    export default {
        props: {
            id: {
                type: String
            },
            resort_id: {
                type: String
            },
            site: {
                type: [Number, String],
                default: 1
            }
        },
        components: {
            'date-picker': DatePick
        },
        data: function ()
        {
            return {
                errors: [],
                server_errors: [],
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                arrival_date: '',
                adults: '',
                children: '',
                flexible: '',
                message: '',
            }
        },
        mounted() {
            initArrivalDatepickers(this.$el, {
                onChange: (arrivalDate) => {
                    this.arrival_date = arrivalDate;
                },
            });
        },
        methods: {
            getCookie(name) {
                const value = '; ' + document.cookie;
                const parts = value.split('; ' + name + '=');

                return parts.length === 2 ? parts.pop().split(';').shift() : '';
            },
            getGclid(form) {
                const field = form ? form.querySelector('input[name="gclid"]') : null;

                if (field && field.value) {
                    return field.value;
                }

                return Number(this.site) === 1 ? this.getCookie('gclid') : '';
            },
            getFieldErrorKey: function (field)
            {
                const fieldName = field.getAttribute('name');

                return {
                    'tx_sbchalets_pi1[name]': 'first_name',
                    'tx_sbchalets_pi1[last_name]': 'last_name',
                    'tx_sbchalets_pi1[email]': 'email',
                    'tx_sbchalets_pi1[telephone]': 'phone',
                    'tx_sbchalets_pi1[arrival_date]': 'arrival_date',
                    'tx_sbchalets_pi1[adults]': 'adults',
                    'tx_sbchalets_pi1[children]': 'children',
                    'tx_sbchalets_pi1[preference]': 'flexible',
                }[fieldName];
            },
            getClientValidationErrors: function (form)
            {
                return Array.from(form.querySelectorAll('input, select, textarea'))
                    .filter((field) => !field.checkValidity())
                    .map((field) => this.getFieldErrorKey(field))
                    .filter((field) => field);
            },
            submit: function (event)
            {
                this.errors = [];
                this.server_errors = [];

                const form = event && event.target ? event.target.closest('form') : null;

                if (form && !form.checkValidity()) {
                    this.errors = this.getClientValidationErrors(form);

                    if (typeof form.reportValidity === 'function') {
                        form.reportValidity();
                    }

                    return;
                }
                
                let attributes = {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                    phone: this.phone,
                    arrival_date: this.arrival_date,
                    adults: this.adults,
                    children: this.children,
                    flexible: this.flexible,
                    chalet_id: this.id,
                    resort_id: this.resort_id,
                    initial_message: this.message,
                    source: 0,
                    gclid: this.getGclid(form) || null,
                    hash: Math.random().toString(36).replace(/[^a-z0-9]+/g, '').substr(0, 32)
                };


                Enquiry.$query().store(attributes)
                .then((enquiry) => {
                    if (this.message)
                    {
                        EnquiryMessage.$query().store({
                            enquiry_id: enquiry.$attributes.id,
                            message: this.message,
                            author: 'client',
                            author_id: 0 // @todo
                        });
                    }

                    window.location.href = this.$root.config.url+'/login/thank-you';
                })
                .catch((e) => {
                    const response = e.response && e.response.data ? e.response.data : {};
                    const validationErrors = response.errors || {};

                    this.errors = Object.keys(validationErrors);
                    this.server_errors = Object.keys(validationErrors)
                        .reduce((messages, field) => messages.concat(validationErrors[field]), []);

                    if (this.server_errors.length === 0) {
                        this.server_errors = [response.message || 'We could not submit your enquiry. Please try again.'];
                    }
                })
            }
        }
    }
</script>
